import React, { useState, useEffect, useRef } from 'react';
import './TimerTool.css'; // Import the new CSS file

function TimerTool() {
  const [seconds, setSeconds] = useState(60);
  const [remaining, setRemaining] = useState(60);
  const [isRunning, setIsRunning] = useState(false);
  const audioRef = useRef(null);
  const beepIntervalRef = useRef(null);

  useEffect(() => {
    let timer = null;
    if (isRunning && remaining > 0) {
      timer = setInterval(() => {
        setRemaining(prev => prev - 1);
      }, 1000);
    } else if (remaining === 0) {
      setIsRunning(false);
      if (audioRef.current) {
        audioRef.current.play();
        if (beepIntervalRef.current) {
          clearInterval(beepIntervalRef.current);
        }
        beepIntervalRef.current = setInterval(() => {
          audioRef.current.currentTime = 0;
          audioRef.current.play();
        }, 1000);
      }
    }
    return () => {
      clearInterval(timer);
      if (beepIntervalRef.current) {
        clearInterval(beepIntervalRef.current);
        beepIntervalRef.current = null;
      }
    };
  }, [isRunning, remaining]);

  const startTimer = () => {
    setRemaining(seconds);
    setIsRunning(true);
  };

  const resetTimer = () => {
    setIsRunning(false);
    setRemaining(seconds);
    if (beepIntervalRef.current) {
      clearInterval(beepIntervalRef.current);
      beepIntervalRef.current = null;
    }
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  return (
    <div className="timer-tool-container fogged-card">
      <h1>⏱️ Basic Rest Timer</h1>

      <div className="timer-description">
        This will play a repeating beep sound when the timer reaches zero.
      </div>

      <span className="timer-remaining">
        <span className="timer-display">{remaining}s</span>
        remaining
      </span>

      <div className="timer-controls">
        <label className="timer-duration-label">
          Set Duration (seconds):
          <input
            type="number"
            value={seconds}
            onChange={(e) => setSeconds(+e.target.value)}
            className="timer-duration-input"
            disabled={isRunning}
          />
        </label>

        <button
          onClick={startTimer}
          disabled={isRunning}
          className="timer-start-button"
        >
          Start
        </button>

        <button onClick={resetTimer} className="timer-reset-button">
          Reset
        </button>
      </div>

      <audio
        ref={audioRef}
        src="https://storage.googleapis.com/heldsolutionsllc-public-bucket/beep_with_silence.mp3"
        preload="auto"
      />
    </div>
  );
}

export default TimerTool;
